import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Text } from "src/components/ui/Text";
import clsx from "clsx";
import { BaseButton } from "src/components/ui/baseButton";
import IconVisibilityOff from "src/assets/images/ic_visibility_off.svg";
import DialogDetailBoxType4 from "./DialogDetailBoxType4";
import { IconProperties } from "./Icon";

const SiteDetailBoxType4 = (props) => {
  const { detailSite, focusSite, onClick, disable } = props;
  const { lang } = useParams();

  const [openDialogDetails, setOpenDialogDetails] = useState(false);

  const getSiteName = detailSite?.Name.includes('"name_english"')
    ? JSON.parse(detailSite?.Name)
    : detailSite?.Name;

  const siteName =
    typeof getSiteName === "string"
      ? getSiteName
      : lang === "th"
      ? getSiteName?.name_thai
      : getSiteName?.name_english;

  const basicInformation = detailSite?.basic_info;
  const location = JSON.parse(detailSite?.location);
  const financialInformation = detailSite?.financial_info;
  const operationalStatus = detailSite?.operational_status?.property_status;

  const PropertyType = basicInformation?.property_type;
  const state = location?.state;

  const onClickCard = () => {
    if (disable) return;

    try {
      onClick(detailSite);
    } catch {}
  };

  return (
    <>
      <div
        className={`flex gap-2 p-4 border border-gray-200 rounded-lg cursor-pointer transition-all duration-300 ${clsx(
          {
            "ring-2 ring-offset-0 ring-vekin-green10 bg-vekin/5":
              focusSite?.Id === detailSite?.Id,
            "hover:border-vekin-green10": focusSite?.Id !== detailSite?.Id,
          }
        )}`}
        onClick={onClickCard}
      >
        {/* left side detail */}
        <div className="w-12 min-w-12 h-12 rounded-full bg-vekin-green60 overflow-hidden">
          {detailSite?.Image?.includes("data:") ? (
            <div className="w-full h-full flex items-center justify-center">
              <IconProperties className="w-6 h-6 stroke-white" />
            </div>
          ) : (
            <img
              className="w-full h-full object-cover"
              src={detailSite.Image}
              alt="image-card"
            />
          )}
        </div>

        {/* right side detail */}
        <div className="flex flex-col gap-2 grow">
          <div className="flex flex-col gap-1">
            <Text variant="medium-14" className={`text-black`}>
              {siteName}
            </Text>
            <Text variant="normal-12" className={`text-vekin-green100`}>
              {(PropertyType || state) &&
                `${PropertyType}${state && ` • ${state}`}`}
            </Text>
          </div>

          <div className="flex items-center gap-2 justify-between">
            {/* status */}
            <div className="rounded-2xl border border-vekin-green10 h-[1.375rem] !min-w-10 p-2 flex items-center justify-center">
              <Text variant="semi-10" className={`text-vekin-green100`}>
                {operationalStatus || "N/A"}
              </Text>
            </div>

            {/* details button */}
            <BaseButton
              variant="secondary"
              size="x-small"
              className={`!min-w-12 flex items-center gap-1 !rounded-md !shadow-none`}
              onClick={(e) => {
                e.stopPropagation();
                setOpenDialogDetails(true);
              }}
            >
              <img
                src={IconVisibilityOff}
                alt="icon-visibility"
                className="w-4 h-4"
              />
              <Text variant="semi-10" className={`text-vekin-green100`}>
                Details
              </Text>
            </BaseButton>
          </div>

          <div className="flex items-center gap-2 justify-between">
            <Text variant="normal-10" className={`text-vekin-green100`}>
              {`Value:`}
            </Text>
            <Text variant="normal-10" className={`text-vekin-green100`}>
              {`${financialInformation?.gross_asset_value.toLocaleString(
                "en-US"
              )} ${financialInformation?.gross_asset_currency || "THB"}`}
            </Text>
          </div>
        </div>
      </div>

      {openDialogDetails && (
        <DialogDetailBoxType4
          open={openDialogDetails}
          onClose={() => setOpenDialogDetails(false)}
          detailSite={detailSite}
        />
      )}
    </>
  );
};

export default SiteDetailBoxType4;
